import { mapActions, mapGetters, mapMutations } from "vuex";

import StarRating from "vue-star-rating";

export default {
    name: "product",
    props: ["product", "isFavorite"],
    data() {
        return {
            addToFavorite: false,
        };
    },
    computed: {
        ...mapGetters({
            basket: `basket/basket`,
            count: `basket/count`,
            popupFastBuy: `card/popupFastBuy`,
            isAuthenticated: `auth/isAuthenticated`,
            popupRegister: "auth/popupRegister",
            user: "profile/user",
            favouriteList: "favorites/whichList",
            favouritesListLength: "favorites/favouritesListLength",
        }),
    },
    components: {
        StarRating,
    },
    mounted() {
        this.product.selected === 1 ? (this.addToFavorite = true) : (this.addToFavorite = false);
    },
    methods: {
        ...mapActions({
            addFavourite: `favorites/ADD_PRODUCT_TO_FAVORITE`,
            removeFromFavourite: `favorites/REMOVE_PRODUCT_IN_FAVORITE`,
        }),
        ...mapMutations({
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        addToBasket(product) {
            this.addBasket({
                select_count: this.count,
                min_price: this.product.min_price,
                select_price: product.discount_price ? product.discount_price : product.price,
                ...product,
            });
            this.$toasted.success(this.$t("successAddBasket"));
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.product.id,
                count: this.product.select_count ? this.product.select_count : 1,
            });
        },
        addFavourites(product) {
            if (this.isAuthenticated) {
                let currentProduct = this.favouriteList.find(favorite => favorite.id === product.id);
                if (currentProduct) {
                    return this.removeItem(currentProduct);
                }
                this.addFavourite(product)
                    .then(() => {
                        this.addToFavorite = true;
                        this.$toasted.success(this.$t("successAddFavourites"));
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 422) {
                        }
                    });
            } else {
                this.changePopupRegister({ show: true, isRedirect: false });
            }
        },
        removeItem(product) {
            this.removeFromFavourite(product)
                .then(() => {
                    this.$toasted.success(this.$t("successRemoveFromFavourites"));
                    this.addToFavorite = false;
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        console.log(this.validationErrors);
                    }
                });
        },
    },
};
